import Divider from 'components/Divider';
import { observer } from 'mobx-react-lite';

import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import ClearAllModal from '../ClearAllModal';
import SaveAsDraft from '../Basket/SaveAsDraft';

export const ProductFooter = observer(() => {
  const cart = useCartContext();
  const navigate = useNavigate();
  const location = useLocation();

  const isAccessProductPage = location.pathname.includes('/access/product');
  const isMobilityProductDetailsPage =
    location.pathname.includes('/product') && !isAccessProductPage;

  const handleCheckout = () => {
    if (location.pathname.includes('/access-express/v3/access')) {
      navigate('/access-express/v3/checkout/access');
    } else {
      navigate('./checkout');
    }
  };
  const onClearAll = () => cart.clearAll();
  const onKeepShopping = () => {
    navigate(-1);
    cart.close();
  };

  const totalItems = cart.totalQuantity;

  return (
    <div className="flex w-full flex-col gap-8">
      {totalItems > 0 && (
        <div className="flex flex-col gap-2">
          <Divider />
          <div className="flex justify-end">
            <ClearAllModal onClick={onClearAll} />
          </div>
        </div>
      )}

      <div className="flex flex-col gap-4">
        <GraniteButton
          variant="tertiary"
          onClick={handleCheckout}
          disabled={totalItems === 0}
        >
          Checkout ({totalItems})
        </GraniteButton>
        {!cart.resumeOrder?.id || isMobilityProductDetailsPage ? (
          <div className="flex justify-between gap-4">
            <SaveAsDraft />
            {isMobilityProductDetailsPage && (
              <GraniteButton
                variant="secondary"
                className="w-full"
                onClick={onKeepShopping}
              >
                Keep shopping
              </GraniteButton>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
});

export default ProductFooter;
